var _g, _g2, _g3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIntroBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 935,
    height: 772,
    viewBox: "0 0 935 772",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1389_2827)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 585,
    cy: 150,
    r: 98,
    fill: "#2DFFF2"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter1_f_1389_2827)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 358.5,
    cy: 86.5,
    r: 87.5,
    fill: "#E650FF"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter2_f_1389_2827)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 372,
    r: 116,
    fill: "#79FF87"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1389_2827",
    x: 235,
    y: -200,
    width: 700,
    height: 700,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 126,
    result: "effect1_foregroundBlur_1389_2827"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1389_2827",
    x: 19,
    y: -253,
    width: 679,
    height: 679,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 126,
    result: "effect1_foregroundBlur_1389_2827"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_1389_2827",
    x: 0,
    y: -28,
    width: 800,
    height: 800,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 142,
    result: "effect1_foregroundBlur_1389_2827"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntroBg);
export default __webpack_public_path__ + "static/media/intro-bg.0d2881bf95e01b965141cbb2c080c66c.svg";
export { ForwardRef as ReactComponent };